import { render, staticRenderFns } from "./chat-attached-html.vue?vue&type=template&id=fdc32880&scoped=true"
import script from "./chat-attached-html.vue?vue&type=script&lang=js"
export * from "./chat-attached-html.vue?vue&type=script&lang=js"
import style0 from "./chat-attached-html.vue?vue&type=style&index=0&id=fdc32880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc32880",
  null
  
)

export default component.exports